






















































































import Vue from 'vue';
import {
  Component,
  Prop,
  Emit,
  Watch,
} from 'vue-property-decorator';
import { VMoney } from 'v-money';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import Rules from '@/shared/rules/rules';
import MetaData from '@/domain/scripts/entity/metadata.entity';
import PeopleManagementService from '@/domain/people-management/service/people-management.service';
import Seniority from '@/domain/people-management/entity/seniority.entity';

@Component({
  components: {
    VbTooltipSlot,
  },
  directives: {
    money: VMoney,
  },
})

export default class KeyValueParameter extends Vue {
  @Prop() data?: MetaData[];

  @Prop() editModeValue!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop({ type: Boolean, default: false }) isPercentInput!: boolean;

  @Prop({ type: Boolean, default: false }) isSeniorityInput!: boolean;

  validationsRules: Rules = new Rules();

  metadataList: MetaData[] = [MetaData.of({})];

  seniorityList: Seniority[] = [];

  created() {
    if (this.data) {
      this.metadataList = this.data
    }
    if (this.isSeniorityInput) {
      this.getSeniorities();
    }
  }

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '$ ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  money2: object = {
    decimal: ',',
    thousands: '.',
    precision: 4,
    prefix: '$ ',
    masked: false,
    max: 9999.9999,
    min: 0.0001,
  };

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '',
    suffix: ' %',
    masked: false,
    max: 100,
    min: 0,
  };

  getSeniorities() {
    PeopleManagementService.getAllSeniorities().then((response) => {
      this.seniorityList = Seniority.ofList(response);
    });
  }

  removeField(field: MetaData) {
    this.metadataList.splice(this.metadataList.indexOf(field), 1)
    this.updateData();
  }

  updateData() {
    this.$emit('updateKeyValue', this.metadataList)
  }

  updateKey(value: string, index: number): void {
    this.metadataList[index].field = value.trim();
    this.$emit('updateKeyValue', this.metadataList);
  }

  addNewField() {
    this.metadataList.push(MetaData.of({}))
  }
}

